import React, { useState } from "react";
import RegisterSecim from "../RegisterSecim/RegisterSecim";
import RegisterAfaziliLeft from "../RegisterAfazili/RegisterAfaziliLeftSide";
import RegisterAfaziliRight from "../RegisterAfazili/RegisterAfaziliRightSide";
import RegisterDoktorLeft from "../RegisterDoktor/RegisterDoktorLeftSide";
import RegisterDoktorRight from "../RegisterDoktor/RegisterDoktorRightSide";
import RegisterDoktorRightFirst from "../RegisterDoktor/RegisterDoktorRightSideFirst";
import RegisterDoktorRightSecond from "../RegisterDoktor/RegisterDoktorRightSideSecond";
import './RegisterPage.css';

const RegisterPage = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [showFirstStep, setShowFirstStep] = useState(false);
    const [showSecondStep, setShowSecondStep] = useState(false);

    return (
        <div className="registerpage-container">
            {/* Eğer seçenek seçilmemişse, seçim sayfasını göster */}
            {!selectedOption && <RegisterSecim setSelectedOption={setSelectedOption} />}

            {/* Seçime göre içerik değiştir */}
            {selectedOption === "afazili" && (
                <div className="register-content">
                    <RegisterAfaziliLeft />
                    <RegisterAfaziliRight />
                </div>
            )}

            {selectedOption === "doktor" && (
                <div className="register-content">
                    <RegisterDoktorLeft />
                    {!showFirstStep ? (<RegisterDoktorRight setShowFirstStep={setShowFirstStep} />) : !showSecondStep ? (
                        <RegisterDoktorRightFirst setShowSecondStep={setShowSecondStep} />
                    ) : (<RegisterDoktorRightSecond />)}
                </div>
            )}
        </div>
    );
};

export default RegisterPage;
